import { IGetShiftListParams, ShiftService } from '../../services/shifts.service';
import { EmployeesService } from '../../services/employees.service';
import { IEmployeeSubscription, IShift } from "../../services/index";
import * as _ from 'lodash';
import * as moment from 'moment';
import { timingSafeEqual } from 'crypto';

class SubscriptionsDashboardController {
    groupedShifts: any;
    isMessageOpen: boolean;
    shiftsGrouping: string;
    filter: any;
    endDate: any;
    startDate: any;
    private sortType: string;
    private shifts: IShift[];
    private days: any = [];
    private currentShift: IShift;
    private subscriptions: IEmployeeSubscription[];
    private newSubscription: IEmployeeSubscription;
    private isInitializing: boolean;
    private maxDistanceFilter: string;
    private functionFilter: string;

    constructor(
        private EmployeesService: EmployeesService,
        private $state: ng.ui.IStateService,
        private $stateParams: ng.ui.IStateParamsService,
        private ShiftService: ShiftService,
        private screenSize: any
    ) {
        "ngInject";
    }

    public $onInit = () => {
        this.isMessageOpen = false;
        this.shiftsGrouping = 'date';
        this.filter = {
            status : null
        }
        this.maxDistanceFilter = '50';
        this.isInitializing = true;
        this.startDate = moment().toDate();
        this.endDate = moment().add(1, 'w').toDate();
        this.getShifts(true, true);
    }

    public handleChildChange = (type, data) => {
        switch (type){
            case 'init':
                this.isMessageOpen = true;
            break;
            case 'update':
                this.getShifts();
            break;
            default : 
            break;
        }
    }

    prevWeek() {
        this.startDate = moment(this.startDate).add(-7, 'day').toDate();
        this.endDate = moment(this.endDate).add(-7, 'day').toDate();
        this.getShifts();
    }

    nextWeek() {
        this.startDate = moment(this.startDate).add(7, 'day').toDate();
        this.endDate = moment(this.endDate).add(7, 'day').toDate();
        this.getShifts();
    }

    setFilters() {
        var filteredShifts = this.shifts;
        
        // filter by distance
        if (this.maxDistanceFilter) {
            var filteredShifts = filteredShifts.filter(s => s.distance < Number(this.maxDistanceFilter));
        }

        // filter by function
        if (this.functionFilter) {
            var filteredShifts = filteredShifts.filter(s => s.functionId === this.functionFilter);
        }
        
        if (this.shiftsGrouping && this.shiftsGrouping == 'date'){
            this.groupShifts(filteredShifts);
        }
    }

    groupShifts(shifts) {
        // console.log('groupShifts')
        this.groupedShifts = _.groupBy(shifts, (item) => {
            return moment(item.start).format('dd DD-MM-YYYY');
        });
    }

    public resetFilters = () => {
        this.filter = {
            search: null,
            status : null,
            createdby: null,
            createdsince: null
        }
        this.getShifts();
    }

    public getShifts = (scrollTo = true, isFirstGet = false) => {
        if (!this.isInitializing || isFirstGet) {
            // console.log('this.getShifts')
            var termTooShort = false;
            this.currentShift = null;
            var params: IGetShiftListParams = {
                from: this.startDate,
                till: this.endDate,
                includeSubscriptions: false,
                includeDistance: true,
                sortfield: 'start',
                sortorder: 'asc'
            }

            if (this.filter) {
                params.status = '2';
                // if (this.filter.status) {
                //     params.status = '2';
                // }
                if (this.filter.search) {
                    if (this.filter.search.length > 3) {
                        params.q = this.filter.search;
                    } else {
                        termTooShort = true;
                    }
                }
                // if (this.filter.createdby) {
                //     params.createdBy = this.filter.createdby;
                //     params.updatedBy = this.filter.createdby;
                // }
                // if (this.filter.createdsince) {
                //     params.createdSince = this.filter.createdsince;
                //     params.updatedSince = this.filter.createdsince;
                // }
            }

            if (!termTooShort) {                
                this.ShiftService.getFilter(params).then((result) => {
                    this.shifts = result;
                    this.setFilters()
                    if (this.isInitializing) {
                        this.isInitializing = false;
                    }
                });
            }
        }
    }

    
}

export const subscriptionsDashboardComponent = {
    controller: SubscriptionsDashboardController,
    bindings: {
        subscriptions: '<',
        functions: '<'
    },
    template: require('./subscriptions.dashboard.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/subscriptions/subscriptions.dashboard.component.ts